export default __webpack_public_path__ + "static/media/logout-green.5a4abace.svg";